// import { ViewSupport45Component } from "../../../components/SupportSystem/ViewReports/ViewSupport45Component";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { OperationReport45Component } from "../../../components/SupportSystem/OperationReportForm/OperationReport45Component";

export function ViewSupport45Container() {
    const titleName =
        "แบบรายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (แบบ ชอ. 4-5)"; //ใส่ชื่อtitle ตรงนี้
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <OperationReport45Component />
            <Footer />
        </div>
    );
}
